import DatabaseModel from './DatabaseModel.js';

// Panel "Situación de informes pendientes (TPI) por inspector". Solo LECTURA del dato materializado
// (informes_pendientes), siempre fresco → cached=false. El botón del calendario no calcula nada; solo
// navega. El materializado lo mantiene el backend (event-driven + reconcile nocturno), gateado por flag.
var InformesPendientes = Object.create(DatabaseModel);

InformesPendientes.model = 'planificacion/informes-pendientes';

// Rejilla: total TPI(No) + tarjetas por inspector (importe desc).
InformesPendientes.rejilla = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model,
        method: 'GET',
        data: {}
    }, false);
};

// Detalle por inspector (sin inspector o "__TODOS__" = todos): KPIs, antigüedad, materias, listado.
InformesPendientes.detalle = function(inspector) {
    var self = this;
    var url = self.server_movilidad + self.prefix + self.model + '/detalle';
    if (inspector && inspector !== '__TODOS__') {
        url += '?inspector=' + encodeURIComponent(inspector);
    }
    return self.sendRequest({ url: url, method: 'GET', data: {} }, false);
};

// Estado del flag (para avisar si la funcionalidad está apagada).
InformesPendientes.estado = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/estado',
        method: 'GET',
        data: {}
    }, false);
};

// Reconstrucción total bajo demanda (gateada por el flag). Para primer llenado / humo.
InformesPendientes.reconcile = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/reconcile',
        method: 'POST',
        data: {}
    }, false);
};

export default InformesPendientes;
